import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ElectricComparatorResult } from 'src/app/components/account/models/ElectricComparatorResult';
import { GasComparatorResult } from 'src/app/components/account/models/GasComparatorResult';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-modal-documents',
  templateUrl: './modal-documents.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalDocumentsComponent implements OnInit {

  public electricComparatorResult: ElectricComparatorResult;
  public gasComparatorResult: GasComparatorResult;
  public contractingInformation: string = "Informatii contractare";
  public newClient: string = "Client nou (construcţie nouă, schimbare proprietar,etc.)";
  public contractConditionsChange: string = "Schimbare condiţii contract (schimbare tip contract, ofertă noua, prelungire contract, etc)";
  public supplierChange: string = "Schimbare furnizor";
  public documentName: string = "Denumire document";
  public documentModel: string = "Model document";
  public download: string = "Descarca";
  public isNewClientDocumentsTableVisible: boolean = true;
  public isContractConditionsChangeDocumentsTableVisible: boolean = false;
  public isSupplierChangeDocumentsTableVisible: boolean = false;
  public newClientDocuments = [];
  public sameSupplierDocuments = [];
  public newSupplierDocuments = [];
  public comparatorDocumentsUrl = environment.comparatorDocumentsUrl;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.electricComparatorResult) {
      this.newClientDocuments = this.electricComparatorResult.documente.filter(x => x.tip_document?.includes("client_nou"));
      this.sameSupplierDocuments = this.electricComparatorResult.documente.filter(x => x.tip_document?.includes("furnizor_existent"));
      this.newSupplierDocuments = this.electricComparatorResult.documente.filter(x => x.tip_document?.includes("furnizor_nou"));
      this.comparatorDocumentsUrl = this.comparatorDocumentsUrl + "contracte/"
    } else if (this.gasComparatorResult) {
      this.newClientDocuments = this.gasComparatorResult.documente.filter(x => x.tip_document?.includes("client_nou"));
      this.sameSupplierDocuments = this.gasComparatorResult.documente.filter(x => x.tip_document?.includes("furnizor_existent"));
      this.newSupplierDocuments = this.gasComparatorResult.documente.filter(x => x.tip_document?.includes("furnizor_nou"));
      this.comparatorDocumentsUrl = this.comparatorDocumentsUrl + "contracte_gaz/"
    }
  }

  onViewDocumentsTable(documentsType: string): void {
    if (documentsType === this.newClient) {
      this.isNewClientDocumentsTableVisible = !this.isNewClientDocumentsTableVisible;
    }
    if (documentsType === this.contractConditionsChange) {
      this.isContractConditionsChangeDocumentsTableVisible = !this.isContractConditionsChangeDocumentsTableVisible;
    }
    if (documentsType === this.supplierChange) {
      this.isSupplierChangeDocumentsTableVisible = !this.isSupplierChangeDocumentsTableVisible;
    }
  }

}
